import React from 'react'

import { textClub } from '../../../../../constants'
import { useStoreContext } from '../../../../../contexts/StoreContext'
import { PriceCustom } from '../../../../ui/PriceCustom'

import './product-card-club-prices.scss'

interface ProductCardClubPricesProps {
  measurementUnit?: string
  clubPrice?: number
  hasUndQtd?: number | string
  hasUnd?: string
}

export const ProductCardClubPrices = ({
  measurementUnit,
  clubPrice,
  hasUndQtd,
  hasUnd,
}: ProductCardClubPricesProps) => {
  const { activatePlusFriendBadge } = useStoreContext()
  const isMeasured = measurementUnit !== 'un'

  return (
    <div className="container-club-price">
      <div className="club-price">
        <p className="club-text" data-testid="club-text">
          {textClub(activatePlusFriendBadge)}
        </p>
        <p className="club-price-text">
          <PriceCustom className="club-price-custom" price={clubPrice} />
          {isMeasured && (
            <span className="club-measure-text">
              /{hasUndQtd}
              {hasUnd}
            </span>
          )}
        </p>
      </div>
    </div>
  )
}
